import type { DetailedHTMLProps, FC, HTMLAttributes, ReactNode } from "react";

import { cn } from "@/utils/common/styleHelper/utils";

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  id?: string;
  className?: string | undefined;
  children: ReactNode;
}

const ContainerComponent: FC<Props> = ({
  id,
  className = "",
  children,
  ...props
}) => {
  return (
    <div
      {...props}
      id={id}
      className={cn("flex flex-col w-full max-w-7xl mx-auto", className)}
    >
      {children}
    </div>
  );
};

export default ContainerComponent;
